import React, { PropsWithChildren, createContext, FC } from 'react';
import { useQuery } from 'react-query';
import { ISettings } from '../interface';
import { SettingsService } from '../services/settings.service';

const initialValues: ISettings = {
  countries: [],
  warehouse: [],
  workinghours: '',
};

export const SettingsContext = createContext<ISettings>(initialValues);

export const SettingsProvider: FC<PropsWithChildren> = ({ children }) => {
  const { data = initialValues } = useQuery<ISettings, Error>(
    ['bootstrap-settings'],
    async () => {
      const response = await SettingsService.getSettings();
      if (response.status === 200) return response.data;
      throw new Error(response.data as string);
    },
    { initialData: initialValues, refetchOnWindowFocus: false, retry: false },
  );

  return <SettingsContext.Provider value={data}>{children}</SettingsContext.Provider>;
};
